<template>
  <div class="page">
    <div
      class="top"
      :class="{
        'has-res': totalCount,
      }"
    >
      <div class="search-wrap">
        <van-search
          v-model="keyword"
          placeholder="请输入搜索关键词"
          show-action
          shape="round"
          @search="handleQuery(true)"
          @focus="handleSearchFocus"
          @blur="handleSearchBlur"
        >
          <template #action>
            <div @click="handleQuery(true)">搜索</div>
          </template>
        </van-search>
      </div>
      <div class="history-search" v-show="historyShow">
        <div class="history-top">
          <h3>搜索历史</h3>
          <van-icon name="delete-o" @click="handleClearHistory" />
        </div>
        <van-tag
          class="history-tag"
          color="rgb(248,248,248)"
          text-color="#333"
          size="large"
          v-for="(item, index) in historyList"
          :key="index"
          @click="handleHistorySearch(item)"
          >{{ item }}</van-tag
        >
      </div>
      <div class="type-filter-wrap">
        <div class="type-wrap">
          <div class="type-item-wrap">
            <div
              class="type-item"
              :class="{ active: resourceFmt === item.value }"
              @click="handleTabIndexChange(item)"
              v-for="(item, index) in shrfidResourceTypeList"
              :key="index"
              v-text="item.label"
            ></div>
          </div>
          <div class="filter-wrap" @click="handleFilterPannelShow">
            <div class="filter-text">高级检索</div>
            <van-icon class="filter" name="filter-o" />
          </div>
        </div>
        <div class="res-wrap" v-show="totalCount">
          <div class="res">
            {{ `为您找到相关结果${totalCount}个` }}
          </div>
        </div>
      </div>
    </div>
    <van-pull-refresh
      class="list-wrap"
      :class="{ 'has-res': totalCount }"
      v-model="refreshing"
      @refresh="handleQuery(true)"
    >
      <van-list
        :immediate-check="false"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多数据"
        @load="handleQuery"
        ref="bookList"
      >
        <div class="aleph-item-wrap" v-for="(item, index) in list" :key="index">
          <div>
            <van-image
              fit="cover"
              class="cover"
              :src="`${ALEPH_BOOK_COVER_URL}${
                item.isbn ? item.isbn.split('#')[0] : item.issn
              }/cover`"
              alt="暂无封面"
            >
              <template v-slot:loading>
                <img
                  width="100%"
                  height="100%"
                  :src="defaultCoverImg"
                  alt="暂无封面"
                />
              </template>
              <template v-slot:error>
                <img
                  width="100%"
                  height="100%"
                  :src="defaultCoverImg"
                  alt="暂无封面"
                />
              </template>
            </van-image>
          </div>
          <div class="text-wrap">
            <div class="text" v-if="item.mTitle">
              <span class="tit">题名：</span>{{ item.mTitle }}
            </div>
            <div class="text" v-if="item.title.resource_blztm">
              {{ item.title.resource_blztm }}
            </div>
            <div class="text" v-if="item.mAuthor.length > 0">
              <span class="tit">责任者：</span>{{ item.mAuthor.join(";") }}
            </div>
            <div class="text" v-if="item.publish && item.publish != 'null'">
              <span class="tit">出版：</span
              >{{
                `${
                  item.publishAddress && item.publishAddress != "null"
                    ? item.publishAddress + ":"
                    : ""
                }${item.publish.split("#")[0]}${
                  item.publicationYear ? "," + item.publicationYear : ""
                }`
              }}
            </div>
            <div class="text" v-if="item.isbn && item.isbn != 'null'">
              <span class="tit">ISBN：</span>{{ item.isbn.split("#")[0] }}
            </div>
            <div class="text van-ellipsis">
              <van-button
                type="info"
                size="small"
                @click="hanldeBookClick(item)"
                >详情</van-button
              >
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-popup
      class="filter-pannel"
      close-on-popstate
      v-model="filterShow"
      position="right"
    >
      <div class="filter-item-wrap">
        <div class="filter-item">
          <div class="filter-title">检索字段</div>
          <div class="filter-con">
            <div
              class="btn"
              :class="{
                active: item.value === tempFilterParam.field,
              }"
              v-for="(item, index) in shrfidSimQryFiledList"
              :key="index"
              v-text="item.label"
              @click="tempFilterParam.field = item.value"
            ></div>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-title">匹配类型</div>
          <div class="filter-con">
            <div
              class="btn"
              :class="{
                active: item.value === tempFilterParam.matchType,
              }"
              v-for="(item, index) in shrfidSimQryMatchTypeList"
              :key="index"
              v-text="item.label"
              @click="tempFilterParam.matchType = item.value"
            ></div>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-title">排序字段</div>
          <div class="filter-con">
            <div
              class="btn"
              :class="{
                active: item.value === tempFilterParam.orderByField,
              }"
              v-for="(item, index) in shrfidSimQryOrderFiledList"
              :key="index"
              v-text="item.label"
              @click="tempFilterParam.orderByField = item.value"
            ></div>
          </div>
        </div>
        <div class="filter-item">
          <div class="filter-title">排序方式</div>
          <div class="filter-con">
            <div
              class="btn"
              :class="{
                active: item.value === tempFilterParam.orderByType,
              }"
              v-for="(item, index) in shrfidSimQryOrderTypeList"
              :key="index"
              v-text="item.label"
              @click="tempFilterParam.orderByType = item.value"
            ></div>
          </div>
        </div>
      </div>
      <div class="filter-bottom">
        <div class="btn btn-reset" @click="handleFilterReset">重置</div>
        <div class="btn btn-sure" @click="handleFilterSure">确认</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getSelectList } from "@/api/common";
import { shrfidSimpleQryListGet } from "@/api/book-search";
import {
  setSessionStorage,
  hasLoginCheck,
  clearLocalStorage,
  getLocalStorage,
  setLocalStorage,
  nowUserCanTest,
} from "@/utils";
import {
  STATUS_CODE_OK,
  DICT_T_SHRFID_RESOURCETYPE, // 学术搜索-资源类型词典
  DICT_T_SHRFID_SIMQRY_FILED, // 学术搜索-检索字段词典
  DICT_T_SHRFID_SIMQRY_ORDERFILED, // 学术搜索-排序字段词典
  DICT_T_SHRFID_SIMQRY_ORDERTYPE, // 学术搜索-排序方式词典
  DICT_T_SHRFID_SIMQRY_MATCHTYPE, // 学术搜索-匹配类型词典
  ALEPH_BOOK_COVER_URL,
  LOCAL_STORAGE_BOOK_HISTORY,
} from "@/config";
export default {
  name: "BookSearch",
  data() {
    return {
      defaultCoverImg: require("@/assets/images/default-img.jpg"),
      shrfidResourceTypeList: [], // 学术搜索-资源类型词典
      shrfidSimQryFiledList: [], // 学术搜索-检索字段词典
      shrfidSimQryOrderFiledList: [], // 学术搜索-排序字段词典
      shrfidSimQryOrderTypeList: [], // 学术搜索-排序方式词典
      shrfidSimQryMatchTypeList: [], // 学术搜索-匹配类型词典
      filterShow: false, // 过滤弹窗显示
      resourceFmt: "", // 资源类型
      field: "",
      matchType: "fuzzy",
      orderByField: "",
      orderByType: "",
      tempFilterParam: {
        field: "",
        matchType: "fuzzy",
        orderByField: "",
        orderByType: "",
      },
      loading: false,
      finished: false,
      refreshing: false,
      pageNo: 1,
      pageSize: 10,
      totalCount: 0,
      list: [],
      historyList: [],
      historyShow: false,
      ALEPH_BOOK_COVER_URL,
      keyword: "",
    };
  },
  async created() {
    Promise.all([
      this.handleShrfidResourceTypeListGet(),
      this.handleShrfidSimQryFiledListGet(),
      this.handleShrfidSimQryOrderFiledListGet(),
      this.handleShrfidSimQryOrderTypeListGet(),
      this.handleShrfidSimQryMatchTypeListGet(),
    ]).then(() => {
      const { keyword } = this.$route.query;
      if (keyword) {
        this.keyword = keyword;
        this.handleQuery(true);
      }
    });
  },
  activated() {
    const { keyword } = this.$route.query;
    if (keyword) {
      this.keyword = keyword;
    }
  },
  methods: {
    // 获取学术搜索-资源类型词典
    async handleShrfidResourceTypeListGet() {
      const { data } = await getSelectList({
        dictTable: DICT_T_SHRFID_RESOURCETYPE,
      });
      if (data.code === STATUS_CODE_OK) {
        this.shrfidResourceTypeList = data.data;
        if (this.shrfidResourceTypeList.length > 0) {
          this.resourceFmt = this.shrfidResourceTypeList[0].value;
        }
      }
    },
    // 获取学术搜索-检索字段词典
    async handleShrfidSimQryFiledListGet() {
      const { data } = await getSelectList({
        dictTable: DICT_T_SHRFID_SIMQRY_FILED,
      });
      if (data.code === STATUS_CODE_OK) {
        this.shrfidSimQryFiledList = data.data;
        if (this.shrfidSimQryFiledList.length > 0) {
          this.field = this.shrfidSimQryFiledList[0].value;
          this.tempFilterParam.field = this.shrfidSimQryFiledList[0].value;
        }
      }
    },

    // 获取学术搜索-排序字段词典
    async handleShrfidSimQryOrderFiledListGet() {
      const { data } = await getSelectList({
        dictTable: DICT_T_SHRFID_SIMQRY_ORDERFILED,
      });
      if (data.code === STATUS_CODE_OK) {
        this.shrfidSimQryOrderFiledList = data.data;
        if (this.shrfidSimQryOrderFiledList.length > 0) {
          this.orderByField = this.shrfidSimQryOrderFiledList[0].value;
          this.tempFilterParam.orderByField =
            this.shrfidSimQryOrderFiledList[0].value;
        }
      }
    },

    // 获取学术搜索-排序方式词典
    async handleShrfidSimQryOrderTypeListGet() {
      const { data } = await getSelectList({
        dictTable: DICT_T_SHRFID_SIMQRY_ORDERTYPE,
      });
      if (data.code === STATUS_CODE_OK) {
        this.shrfidSimQryOrderTypeList = data.data;
        if (this.shrfidSimQryOrderTypeList.length > 0) {
          this.orderByType = this.shrfidSimQryOrderTypeList[0].value;
          this.tempFilterParam.orderByType =
            this.shrfidSimQryOrderTypeList[0].value;
        }
      }
    },

    // 获取学术搜索-匹配类型词典
    async handleShrfidSimQryMatchTypeListGet() {
      const { data } = await getSelectList({
        dictTable: DICT_T_SHRFID_SIMQRY_MATCHTYPE,
      });
      if (data.code === STATUS_CODE_OK) {
        this.shrfidSimQryMatchTypeList = data.data;
      }
    },

    handleTabIndexChange(item) {
      this.resourceFmt = item.value;
      this.handleQuery(true);
    },
    // 高级检索弹窗显示
    handleFilterPannelShow() {
      this.filterShow = true;
    },
    // 高级检索过滤重置
    handleFilterReset() {
      this.tempFilterParam = {
        field: this.shrfidSimQryFiledList[0]?.value,
        matchType: "fuzzy",
        orderByField: this.shrfidSimQryOrderFiledList[0]?.value,
        orderByType: this.shrfidSimQryOrderTypeList[0]?.value,
      };
    },
    // 高级检索过滤确认
    handleFilterSure() {
      this.field = this.tempFilterParam.field;
      this.matchType = this.tempFilterParam.matchType;
      this.orderByField = this.tempFilterParam.orderByField;
      this.orderByType = this.tempFilterParam.orderByType;
      this.filterShow = false;
      this.handleQuery(true);
    },

    // 书刊点击事件
    hanldeBookClick(item) {
      const that = this;
      hasLoginCheck({
        tip: "请先登录",
        path: that.$route.fullPath,
        callBack: async () => {
          setSessionStorage("queryParam", item);
          that.$router.push({
            path: "/alephHoldDetail",
          });
        },
      });
    },

    // 查询
    async handleQuery(isRefresh = false) {
      const that = this;
      if (!(await nowUserCanTest())) {
        return;
      }
      const keyword = this.keyword.trim();
      if (!keyword) {
        return;
      }
      if (isRefresh) {
        that.pageNo = 1;
        that.loading = true;
        that.finished = false;
      }
      const { data } = await shrfidSimpleQryListGet({
        pageNo: that.pageNo,
        pageSize: that.pageSize,
        resourceFmt: [that.resourceFmt],
        value: keyword,
        field: that.field,
        matchType: that.matchType,
        orderByField: that.orderByField,
        orderByType: that.orderByType,
      });
      if (data.code === STATUS_CODE_OK) {
        that.refreshing = false;
        that.loading = false;
        that.totalCount = data.data.totalCount;
        const list = data.data.bookList.map((book) => {
          book.mTitle = book.title.resource_ztm;
          if (book.title.resource_qttmxx) {
            book.mTitle =
              book.mTitle + "：" + book.title.resource_qttmxx.split("#")[0];
          }
          if (book.title.resource_ztbxcfjbs) {
            book.mTitle = book.mTitle + "." + book.title.resource_ztbxcfjbs;
          }
          if (book.title.resource_ztbxcfjtm) {
            if (book.title.resource_ztbxcfjbs) {
              book.mTitle = book.mTitle + "，" + book.title.resource_ztbxcfjtm;
            } else {
              book.mTitle = book.mTitle + "." + book.title.resource_ztbxcfjtm;
            }
          }
          book.mAuthor = [];
          if (book.detailData.resource_zrz) {
            const zrzList = book.detailData.resource_zrz.split("#");
            const zrfsList = book.detailData.resource_zrfs.split("#");
            zrzList.forEach((z, index) => {
              book.mAuthor.push(`${z}(${zrfsList[index]})`);
            });
          }
          return book;
        });
        if (isRefresh) {
          that.list = list;
        } else {
          that.list = [...that.list, ...list];
        }
        if (data.data.hasMore == "Y") {
          that.finished = false;
        } else {
          that.finished = true;
        }
        that.pageNo++;
        if (keyword && !that.historyList.includes(keyword)) {
          that.historyList.unshift(keyword);
          that.historyList = that.historyList.slice(0, 10);
          setLocalStorage(LOCAL_STORAGE_BOOK_HISTORY, that.historyList);
        }
      }
    },
    // 搜索框聚焦
    handleSearchFocus() {
      if (!getLocalStorage(LOCAL_STORAGE_BOOK_HISTORY)) {
        this.historyList = [];
        setLocalStorage(LOCAL_STORAGE_BOOK_HISTORY, this.historyList);
      } else {
        this.historyList = getLocalStorage(LOCAL_STORAGE_BOOK_HISTORY);
      }
      if (this.historyList.length > 0) {
        this.historyShow = true;
      }
    },
    // 搜索框失去焦点
    handleSearchBlur() {
      setTimeout(() => {
        this.historyShow = false;
      }, 100);
    },
    // 点击搜索历史里值去搜索
    handleHistorySearch(value) {
      this.keyword = value;
      this.handleQuery(true);
    },
    // 清楚历史搜索记录
    handleClearHistory() {
      clearLocalStorage(LOCAL_STORAGE_BOOK_HISTORY);
    },
  },
};
</script>

<style>
.van-dropdown-menu__bar {
  box-shadow: none !important;
}
.van-dropdown-menu__title {
  font-size: 14px !important;
}
</style>

<style scoped lang="scss">
.page {
  background-color: #f7f8fa;
  .top {
    background-color: #fff;
    height: 150px;
    border-bottom: 1px solid #eee;
    &.has-res {
      height: 175px;
    }
    .type-filter-wrap {
      padding: 10px 10px 5px 10px;
      .type-wrap {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .type-item-wrap {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          flex: 1;
          width: 0;
          .type-item {
            border: 1px solid #1282f4;
            color: #1282f4;
            background-color: #fff;
            padding: 6px 6px;
            border-radius: 50px;
            font-size: 12px;
            margin: 0 10px 10px 0;
            &:last-child {
              margin-right: 0;
            }
            &.active {
              background-color: #1282f4;
              color: #fff;
            }
          }
        }
        .filter-wrap {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 14px;
          flex: 0 0 80px;
          padding-top: 5px;
          .filter {
            margin-left: 2px;
            font-size: 16px;
          }
        }
      }
      .sort-wrap {
        display: flex;
        align-items: center;
        padding-top: 10px;
        justify-content: space-between;
        .sort-item {
          display: flex;
          align-items: center;
          font-size: 14px;
          padding: 0 18px 0 15px;
          &:first-child {
            padding-left: 5px;
          }
          position: relative;
          &::before {
            position: absolute;
            content: "";
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-bottom: 4px solid #999;
            top: 4px;
            right: 4px;
          }
          &::after {
            position: absolute;
            content: "";
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid #999;
            bottom: 4px;
            right: 4px;
          }
          &.active {
            &.sort-up {
              &::before {
                border-bottom: 4px solid #f96e2f;
              }
            }
            &.sort-down {
              &::after {
                border-top: 4px solid #f96e2f;
              }
            }
          }
          .sort-text {
            &.active {
              color: #f96e2f;
            }
          }
        }
      }
      .res-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 5px;
        .res {
          color: #9195a3;
          padding-left: 3px;
        }
      }
    }
    .history-search {
      position: fixed;
      background-color: #fff;
      padding: 5px 10px;
      left: 0;
      right: 0;
      top: 54px;
      bottom: 0;
      z-index: 700;
      height: 200px;
      .history-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 5px;
        padding-bottom: 10px;
      }
      .history-tag {
        border-radius: 5px;
        margin-right: 10px;
        margin-top: 10px;
      }
    }
  }
  .list-wrap {
    position: fixed;
    left: 0;
    right: 0;
    top: 150px;
    bottom: 0;
    z-index: 666;
    overflow-y: auto;
    &.has-res {
      top: 175px;
    }
    .normal-row {
      display: flex;
      margin-top: 12px;
      text-indent: 2em;
      padding-bottom: 5px;
      .tit {
        flex: none;
        color: #000;
        &.white {
          color: #fff;
        }
      }
      .con {
        flex: 1;
        width: 0;
        color: #777;
        display: flex;
        flex-wrap: wrap;
        .ids {
          margin-right: 5px;
          &:last-child {
            margin-right: 0;
          }
        }
        &.collapse {
          line-height: 22px;
          padding-right: 16px;
          position: relative;
        }
        .collapse-wrap {
          display: flex;
          align-items: center;
          .icon {
            margin-left: 3px;
          }
        }
        .arrow-down,
        .arrow-up {
          position: absolute;
          right: 0;
          bottom: 3px;
        }
      }
    }
    .aleph-item-wrap {
      display: flex;
      padding: 10px;
      background-color: #fff;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      .cover {
        width: 100px;
        height: 156px;
        margin-right: 10px;
      }
      .text-wrap {
        flex: 1;
        width: 0;
        .text {
          margin-bottom: 6px;
          color: #777;
          .tit {
            color: #000;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .filter-pannel {
    width: 260px;
    background-color: #f7f8fa;
    padding-bottom: 60px;
    height: 100%;
    .filter-item-wrap {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 60px;
      overflow-y: auto;
      .filter-item {
        margin-bottom: 10px;
        background-color: #fff;
        padding: 0 10px 10px 10px;
        &:last-child {
          margin-bottom: 0;
        }
        .filter-title {
          color: #000;
          padding: 10px 0;
        }
        .filter-con {
          display: flex;
          flex-wrap: wrap;
          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #333;
            background-color: #eee;
            border-radius: 50px;
            min-width: 60px;
            padding: 0 10px;
            height: 30px;
            font-size: 12px;
            margin: 5px;
            &.active {
              background-color: #1282f4;
              color: #fff;
            }
          }
        }
      }
    }
    .filter-bottom {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        padding: 6px 12px;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #f96e2f;
        background-color: #fff;
        border: 1px solid #f96e2f;
        min-width: 100px;
        &.btn-sure {
          background-color: #f96e2f;
          color: #fff;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
